module.exports = __webpack_public_path__ + "img/startConfigurationMemoires@2x.7cd96ab.png";